var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4091 11.6857C20.4091 12.4798 20.0255 13.5569 19.3804 14.7777C18.7445 15.9811 17.8909 17.2579 17.0288 18.4315C16.1681 19.6033 15.3064 20.6623 14.6591 21.4288C14.3772 21.7628 14.1363 22.0409 13.9545 22.248C13.7728 22.0409 13.5319 21.7628 13.2499 21.4288C12.6027 20.6623 11.7409 19.6033 10.8802 18.4315C10.0182 17.2579 9.16463 15.9811 8.52872 14.7777C7.88358 13.5569 7.5 12.4798 7.5 11.6857C7.5 8.28783 10.371 5.5 13.9545 5.5C17.5381 5.5 20.4091 8.28783 20.4091 11.6857Z",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9545,
    cy: 11.9545,
    r: 1.54545,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.6c9606571e2d7fb53c2a0d532f8d4657.svg";
export { ForwardRef as ReactComponent };